import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { Navigate } from '@tanstack/react-router'
import { UnderConstruction } from '../UnderConstruction/UnderConstruction'

export const RoleBasedPlaceholder = () => {
    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <UnderConstruction />
            </RoleRestrictedContent>
        </>
    )
}
